import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializePractice, createLead } from '../services/api';
import { RootState } from '../redux/store';
import { initFailure, initSuccess, startInit, setLeadId } from '../redux/slices/authSlice';
import { extractAttributionParams } from '../utils/helpers';

export function useInitPractice() {
  const dispatch = useDispatch();
  const { token, practice, loading, error } = useSelector((s: RootState) => s.auth);

  const init = useCallback(async (practiceId: string) => {
    dispatch(startInit());
    try {
      const result = await initializePractice(practiceId);
      dispatch(initSuccess({ token: result.token, refreshToken: result.refresh_token, practice: result.practice }));

      // Create lead after successful practice initialization
      try {
        const attributionParams = extractAttributionParams();

        // Only create lead if there are attribution parameters present
        if (Object.keys(attributionParams).length > 0) {
          
          const leadResponse = await createLead({
            lead_type: 'marketing',
            source_type: 'click',
            attribution_params: attributionParams,
          });

          if (leadResponse?.data?.id) {
            dispatch(setLeadId(leadResponse.data.id));
          }
        }
      } catch (leadError) {
        console.error('Failed to create lead:', leadError);
      }

      return result;
    } catch (e: any) {
      if (e?.response?.status !== 401) {
        dispatch(initFailure(e?.message || 'Initialization failed'));
      }
      throw e;
    }
  }, [dispatch]);

  return { token, practice, loading, error, init };
}